import { Quadrant } from '../../models/reaction-set-enums';
import { Channel } from './channel';
import { ResultMapper } from './result-mapper';
import { Result } from './resultGroups';
import { ResultPangolianMapper } from './ResultPangolianMapper';
import { SampleExternalResult } from './sample-external-result';
export class CovidSamples {
    barcode : string;
    positionRow : number;
    prositionCol : number;
    cpValue : number;
    result : string;
    originalResult: string;
    inValidResult : boolean;
    comments : string;
    quadrant: Quadrant;
    contaminationType: string;
    twoSwabsComment: string;
    defaultContaminationComment: string;
    boxId: string;
    receivedBatchID: string;
    channels: Channel[];
    results: Result[] = [];
    nonConformanceProblem: string;
    documentBarcode:string;
    customersBarcode:string;
    icrChannelUpdateIndex: number;
    icrChannelUpdateResult: boolean;
    unboxedSender: string;
    singleSampleRedo: boolean;
    archiveSlot: number;
    cyclerManufacturer: string;
    extractorManufacturer: string;
    archievePositionRow: number;
    archievePositionCol: number;
    singleSampleInconclussiveRedo: boolean;
    singleSampleTechnicalRedo: boolean;
    destination: string;
    shippedUserPUID: string;
    shippedTimestamp: Date;
    externalResult: string;
    externalResults: SampleExternalResult[];
    externalResultCompletionDate: Date;
    sampleType:string;
    parentBatchID: string;
    positionRow96: number;
    positionCol96: number;
    linageClassification: ResultPangolianMapper[];
    lastImportedDateTimeForMutationAnalysis: Date;
    lastRunForMutationAnalysis: string;
    snpDetailsView: SnpProfileForPlate;
    scanTimeStamp : Date;
    sampleQC: ResultMapper[];
    tagPlateId: string;
    u7Sequence: string;
    u5Sequence: string;
    libConcentration: number;
    doNotSequence: boolean;
    allowSequence: boolean;
    molarity: number;
}

export class DilutedCovidSamples{
    barcode : string;
    positionRow : number;
    prositionCol : number;
    cp : number;
    position: string;
    parent: string;
}

export class MachineShortInfo {
    machineName : string;
    machineBarcode : string;
    subType : string;
}

export class MutationInfo{
    mutationAnalysis: MutationCoverage[];
    mutationInfoImportedDatetime: Date;
    dateFromPath: Date
}

export class MutationCoverage{
    mutation: string;
    frequency: string;
}

export class SnpProfileForPlate{
    p1TotalCount: number;
    totalCount: number;
    sexDetermination: string;
}
